import { Component, OnInit } from '@angular/core';

declare var jQuery:any;

var closeSession:any;

@Component({
  selector: 'app-http-error',
  templateUrl: './http-error.component.html',
  styleUrls: ['./http-error.component.css']
})
export class HttpErrorComponent implements OnInit {

  public static CONNECTION_TIME_OUT :number = 0;
  public static SESS_EXPIRED_STATUS :number = 401;
  public static FORBIDDEN :number = 403; 
  public static FILE_NOT_FOUND_STATUS :number = 404;
  public static FILE_NOT_FOUND_MSG :string = 'File was not found';
  public static FORBIDDEN_MSG :string = 'Please contact your system administrator';
  public static SESS_EXPIRED_MSG :string = 'Session has expired, please login again';
  public static NO_LOCATIONS_FOUND_MSG :string = 'No locations found';
  public static CONNECTION_TIME_OUT_MSG :string = 'Connection time out due to hibernate';

  constructor() { }

  ngOnInit() {
  }

  
  show(message: string,title:string){

    if (message == HttpErrorComponent.SESS_EXPIRED_MSG) {
      closeSession = true;
    }
    else {
      closeSession = false;      
    }

    console.log('show() message: '+ message)
    jQuery('#errorModal').modal('show');
    jQuery('#errorModal').find('.modal-title').text(title)
    jQuery('#errorModal').find('.modal-body').text(message)
    
  }

  close(){
    console.log('HttpErrorComponent close()');
    jQuery('#errorModal').modal('hide');    
  }

  closeSession(){

    if (closeSession == true) {
      console.log('closeSession')
   
    }
    jQuery('#errorModal').modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/http-error/http-error.component.ts